import { CanSendSafetyRequest } from "app/PermissionChecker";
import HomeWidgetLayout from "components/layout/HomeWidgetLayout";
import { useTranslation } from "react-i18next";
import { useLaunchAlarmMutation } from "../dashboard/api/safetyApiSlice";
import { useState } from "react";

export function QuickSosWidget() {
    const [t, i18n] = useTranslation(["global", "safety"]);
    const [launchAlarm] = useLaunchAlarmMutation();
    const [isLoading, setIsLoading] = useState(false);
    const [timer, setTimer] = useState(null);

    const handleMouseDown = () => {
        setIsLoading(true);
        const newTimer = setTimeout(() => {
            setIsLoading(false);
            launchAlarm();

        }, 1000);
        setTimer(newTimer);
    };

    const handleMouseUp = () => {
        setIsLoading(false);
        clearTimeout(timer);
    };

    return (
        <HomeWidgetLayout
            title={"Safety"}
            permission={CanSendSafetyRequest}
            content={
                <>
                    <p className="text-muted"> <i className="fa-solid fa-bullhorn fa-xl"></i></p >
                    <p>{t("safety:widget.quick_sos.launch_alarm")}</p>

                    <button
                        className={`btn btn-danger mt-2 ${isLoading ? 'loading' : ''}`}
                        type="button"
                        onTouchStart={handleMouseDown}
                        onTouchEnd={handleMouseUp}
                        onMouseDown={handleMouseDown}
                        onMouseUp={handleMouseUp}
                        onMouseLeave={handleMouseUp} // Per gestire il caso in cui il mouse esca dal pulsante
                    >
                        <a className="nav-link">
                            {isLoading ? <><span className="spinner-border spinner-border-sm ms-2" role="status" aria-hidden="true"></span> {t("safety:widget.quick_sos.hold_down")}</> : " SOS"}
                        </a>
                    </button>
                </>
            }
        />
    );
}
